import { render, staticRenderFns } from "./index.vue?vue&type=template&id=561c4acf&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=561c4acf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561c4acf",
  null
  
)

export default component.exports